import { newE2EPage } from '@stencil/core/testing';

describe('back-to-top', () => {
  it('renders', async () => {
    const page = await newE2EPage();
    await page.setContent('<back-to-top></back-to-top>');

    const element = await page.find('back-to-top');
    expect(element).toHaveClass('hydrated');
  });
});
